import { addColumns } from '@nozbe/watermelondb/Schema/migrations'

export default {
  toVersion: 9,
  steps: [
    addColumns({
      table: 'messages',
      columns: [{ name: 'location', type: 'string' }]
    })
  ]
}
